import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Checkbox from '@components/shared/Checkbox';
import Colors from '@components/shared/Colors';
import { P } from '@components/shared/Typography';

interface Props {
  onClick: () => void;
  checked: boolean;
}

export default function Marketing({ onClick, checked }: Props) {
  const { t } = useTranslation();
  return (
    <CheckboxContainer onClick={onClick} data-testid="marketing-checkbox">
      <Checkbox checked={checked} style={{ marginRight: 15 }} />
      <PStyled>{t('components.news-and-promotions')}</PStyled>
    </CheckboxContainer>
  );
}

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: left;
`;

const PStyled = styled(P)`
  padding-top: 2px;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${Colors.navyBlue};

  @media (max-width: 768px) {
    font-size: 14px;
  }

  a {
    font-weight: bold;
    color: inherit;
  }
`;
